import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import WithSidebar from 'Layout/WithSidebar';
import { LabelButton } from 'components/buttons/LabelButton/LabelButton';
import GradientText from 'components/GradientText';
import ProductItems from 'components/ProductItems';
import Filter from 'components/Filter';
import Banner from 'components/Banner';
import { cropNutritionPrograms } from 'components/Filter/mockData';
import DefaultForm from 'components/FormSection/Forms/DefaultForm';
import {
    selectCropNutritionPage,
    fetchCropNutritionPage,
    selectCropNutritionPageCrops,
} from 'store/slices/CropNutritionSlice';
import { ROUTES } from 'constants/routes';
import { fetchCropNutritionPageCrops } from 'store/slices/CropNutritionSlice';
import { type_nutrition } from 'api/constants';

const CropNutritionPrograms = () => {
    const dispatch = useDispatch();
    const { fs_title, fs_title_background, fs_view_button, agricultural_tag, agricultural_title } =
        useSelector(selectCropNutritionPage);
    const crops = useSelector(selectCropNutritionPageCrops);

    useEffect(() => {
        // @ts-ignore
        dispatch(fetchCropNutritionPage());
        // @ts-ignore
        dispatch(fetchCropNutritionPageCrops({ type: type_nutrition, all: true }));
    }, [dispatch]);

    return (
        <>
            <Banner title={fs_title} image={fs_title_background} buttonText={fs_view_button} />

            <section className="container">
                <div className="inner-container type-3">
                    <div className="main-text-container">
                        <LabelButton>{agricultural_tag}</LabelButton>
                        <GradientText>
                            <span dangerouslySetInnerHTML={{ __html: agricultural_title }} />
                        </GradientText>
                    </div>
                </div>

                <WithSidebar Sidebar={<Filter data={cropNutritionPrograms} />}>
                    <div className="box">
                        <ProductItems data={crops} baseRoute={ROUTES.cropNutritionPrograms} />
                    </div>
                </WithSidebar>
            </section>

            <DefaultForm />
        </>
    );
};

export default CropNutritionPrograms;
